var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-name"},[_c('div',[_vm._v(_vm._s(_vm.item.customer.name))]),_c('div',[_vm._v(_vm._s(_vm.getCustomerShippingAddress(_vm.item)))]),(_vm.item.customer.company_name)?_c('div',{staticClass:"text-muted"},[_c('small',[_vm._v(_vm._s(_vm.item.customer.company_name))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }